"use client"
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import DomainDataTable from './DomainDataTable';

const InterDomains = () => {
  return (
    <div className="container my-4">
      <Tabs defaultActiveKey="tab1" id="inter-domains-tabs" className="mb-3 border-0 justify-content-center">
        <Tab eventKey="tab1" title="All Domains">
          <DomainDataTable countryname="all"/>
        </Tab>
        
        <Tab eventKey="tab2" title="Generic Domains">
          <DomainDataTable countryname ="Generic"/>
        </Tab>
        
        <Tab eventKey="tab3" title="International Domains">
          <DomainDataTable countryname = "European"/>
        </Tab>

        <Tab eventKey="tab4" title="European Domains">
          <DomainDataTable countryname ="European" />
        </Tab>

        <Tab eventKey="tab5" title="Asia Pacific Domains">
          <DomainDataTable countryname ="Asia-Pacific" />
        </Tab>

        <Tab eventKey="tab6" title="American Domains">
          <DomainDataTable countryname ="American" />
        </Tab>

        <Tab eventKey="tab7" title="African Domains">
          <DomainDataTable countryname ="African" />
        </Tab>
      </Tabs>
    </div>
  );
};

export default InterDomains;
